import TEALIUM from "../../../enums/tealium-enums";
import { track } from "../../../util/tealium";

export const closeProfileClickTrack = () => {
  track(
    TEALIUM.U_TAG_METHOD.LINK,
    TEALIUM.EVENT_NAME.CLICK_ACTION,
    "",
    TEALIUM.CATEGORY.GLOBAL_CUSTOMER_PROFILE,
    "",
    "close_profile",
  );
};
